module.exports = __webpack_public_path__ + "static/media/navigate_next_white.673bf86c.svg";